module.exports = __webpack_public_path__ + "img/Woman_Arms_Up.8d85ba1.png";